// Common routes - available for both logged in and not logged in users
import React from 'react'
import { Route } from 'react-router-dom'
import Unsubscribe from '../../containers/Unsubscribe'
import SignUp from '../../containers/Authentication/screens/SignUp'
import InviteAccept from '../../containers/Authentication/screens/InviteAccept/InviteAccept'
import InviteProfileSetup from 'containers/Profile/CompanySettings/InviteProfileSetup/InviteProfileSetup'
import InvitationValidateGate from '../../containers/Authentication/screens/InvitationValidateGate/InvitationValidateGate'
import { LazyDigitalComplianceLabelPage, LazyPackagingLabelVerificationPage } from './heavyRouteChunks'

/**
 * Get common routes
 * These routes are available regardless of authentication status
 * @returns {JSX.Element} React fragment with routes
 */
export const getCommonRoutes = () => {
	return (
		<>
			<Route
				path='/unsubscribe/:token'
				element={<Unsubscribe />}
			/>
			<Route
				path='/invitation/:token'
				element={<InvitationValidateGate />}
			/>
			<Route
				path='/invitation'
				element={<InvitationValidateGate />}
			/>
			<Route
				path='/invite/accept'
				element={<InviteAccept />}
			/>
			<Route 
				path="/invite/profile" 
				element={<InviteProfileSetup />} 
			/>
			<Route
				path='/signup/:token'
				element={<SignUp />}
			/>
			<Route
				path='/signup'
				element={<SignUp />}
			/>
			<Route
				path='/digital-compliance-label/:labelToken'
				element={<LazyDigitalComplianceLabelPage />}
			/>
			<Route
				path='/l/package/:uuid'
				element={<LazyPackagingLabelVerificationPage />}
			/>
		</>
	)
}

/**
 * @deprecated Use getCommonRoutes() — referral signup token route is included there.
 * @returns {JSX.Element} React fragment with routes
 */
export const getCommonRoutesWithSignup = () => getCommonRoutes()
